var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObjectActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.747 5.633c-.7-3.08-3.387-4.466-5.747-4.466h-.007c-2.353 0-5.046 1.38-5.746 4.46-.78 3.44 1.326 6.353 3.233 8.186A3.62 3.62 0 0 0 8 14.833c.907 0 1.813-.34 2.513-1.02 1.907-1.833 4.014-4.74 3.234-8.18M8 8.973a2.1 2.1 0 1 1 0-4.2 2.1 2.1 0 0 1 0 4.2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectActive);
export default __webpack_public_path__ + "static/media/objectActive.3cfa3bedf861257b05d1397c3dd604bf.svg";
export { ForwardRef as ReactComponent };